import 'css-chunksrc/client/scenes/folderRemoval/styles.scss';export default {
  "header": "_header_1cuh9_1",
  "group": "_group_1cuh9_5",
  "text": "_text_1cuh9_9",
  "warning": "_warning_1cuh9_14",
  "name": "_name_1cuh9_19",
  "main": "_main_1cuh9_25",
  "buttons": "_buttons_1cuh9_32"
};